import { render, staticRenderFns } from "./verify-identity-modal.vue?vue&type=template&id=78efea50&scoped=true&"
import script from "./verify-identity-modal.vue?vue&type=script&lang=js&"
export * from "./verify-identity-modal.vue?vue&type=script&lang=js&"
import style0 from "./verify-identity-modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=78efea50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78efea50",
  null
  
)

component.options.__file = "verify-identity-modal.vue"
export default component.exports